import { FilterFieldType, IFilter } from './types'

export const ATLAS_DOC_STATUSES = ['draft', 'published', 'archived'] as const
export const ATLAS_DOC_EMBEDDING_STATUSES = ['pending', 'embedded', 'failed'] as const

/**
 * Common doc types — seeded list. Users can create docs with any string
 * docType, but these are the known values that drive the filter dropdown.
 */
export const ATLAS_DOC_TYPES = [
  'internal_reference',
  'underwriting_policy',
  'sop',
  'salesforce_api',
  'playbook',
  'org_chart',
  'guide',
  'glossary',
  'other',
] as const

/**
 * Column order in the config drives the column order in the table (via
 * TableFiltersRow). Column body cells must be rendered in the same order.
 */
export const ATLAS_DOCS_FILTERS_CONFIG = [
  {
    field: 'title',
    dbField: 'title',
    alias: 'doc',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Title',
  },
  {
    field: 'docType',
    dbField: 'doc_type',
    alias: 'doc',
    type: FilterFieldType.List,
    isSortable: true,
    isMultiple: true,
    title: 'Doc Type',
    options: ATLAS_DOC_TYPES.map((value) => ({ value, label: value })),
  },
  {
    field: 'status',
    dbField: 'status',
    alias: 'doc',
    type: FilterFieldType.List,
    isSortable: true,
    isMultiple: true,
    title: 'Status',
    options: ATLAS_DOC_STATUSES.map((value) => ({ value, label: value })),
  },
  {
    field: 'embeddingStatus',
    dbField: 'embedding_status',
    alias: 'doc',
    type: FilterFieldType.List,
    isSortable: true,
    isMultiple: true,
    title: 'Embedding',
    options: ATLAS_DOC_EMBEDDING_STATUSES.map((value) => ({ value, label: value })),
  },
  {
    // Display-only column — tag chips render in the body; no filter UI.
    field: 'tags',
    type: FilterFieldType.Text,
    title: 'Tags',
    excludeFilter: true,
  },
  {
    // Sortable, display-only usage metric — mirrors the Saved Prompts
    // 'Use Count' column (atlasPrompts.ts). No filter UI.
    field: 'hitCount',
    dbField: 'hit_count',
    alias: 'doc',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Hit Count',
    excludeFilter: true,
    align: 'right' as const,
  },
  {
    field: 'lastRetrievedAt',
    dbField: 'last_retrieved_at',
    alias: 'doc',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Last Retrieved',
    excludeFilter: true,
  },
  {
    field: 'updatedAt',
    dbField: 'updated_at',
    alias: 'doc',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Last edited',
  },
] as const satisfies IFilter[]
